export function playernames(players) {
    return players.map(player => player).join(", ")
}